import templateUrl from "emun.customer/customer-change-rep.htm";
import open from "webmodals/open";
import modals from "webmodals/modals";
import ServiceBus from 'servicestack/service-bus'
import basicController from "servicestack/basic.controller.properties";

class controller {
  constructor($scope, options) {
    const $ctrl = this;
	basicController($ctrl);
	$ctrl.bus = $ctrl.$session.bus;
    $ctrl.title = options.title || " Change Sales Rep...";
    $ctrl.retailerIds = options.RetailerIds || [];
	$ctrl.request = {
    RetailerIds: $ctrl.retailerIds,
		SalesRepId: ""
	};
    $ctrl.submit = () => {
		$ctrl.bus.send("ChangeSalesRep.json", $ctrl.request).then(res => {
			$ctrl.$close({ updated: $ctrl.request.NewId });
		});
    };
  }

}

export default {
  open(options) {
    return modals.open(
      Object.assign(
        {
          templateUrl,
          resolve: {
            options: () => options
          },
          bindToController: true,
          controller,
          controllerAs: "$ctrl",
          size: "md"
        },
        (options || {}).modal
      )
    ).result;
  }
};

